import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dep0103CtlrOut } from 'app/core/models/api/dep/dep0103'
import {
    selectDep0103,
    selectDep0103False,
} from 'app/core/services/prd/dep.service'
import { RootState } from 'app/core/store'

export type MobileAuth = Dep0103CtlrOut

const initialState: MobileAuth = {
    onbnCusYn: '', //ONBN_CUS_YN      : '', // 당행고객여부
    cpnMdfcYn: '', //CPN_MDFC_YN      : '', // 휴대폰번호변경여부
    //RNL_TGT_YN      : '', // 갱신대상여부
    cusEddTgtRgsnYn: '', //CUS_EDD_TGT_RGSN_YN    : '', // 갱신대상여부->고객EDD대상등록여부
    ebkJnngYn: '', //EBK_JNNG_YN      : '', // 전자금융가입여부
    adrMdfcYn: '', //ADR_MDFC_YN      : '', // 주소변경여부
    rdnmUseYn: '', //RDNM_USE_YN      : '', // 도로명사용여부
    trnAblYn: '', //TRN_ABL_YN      : '', // 거래가능여부 (이어가기 존재여부)
    nofcIotaHoldYn: '', //NOFC_IOTA_HOLD_YN    : '', // 비대면입출식계좌보유여부
    mngmBrcd: '', //MNGM_BRCD      : '', // 관리부점코드
    fntrObjtCnfaEctgYn: '', //FNTR_OBJT_CNFA_ECTG_YN   : '', // 금융거래목적확인제외대상여부
    fntrLmacHoldYn: '', //FNTR_LMAC_HOLD_YN    : '', // 금융거래한도계좌보유여부
    fntrObjtCnfaTgynRsltCon: '', //FNTR_OBJT_CNFA_TGYN_RSLT_CON : '', // 금융거래목적확인대상여부결과내용
    edpsCsn: -1, //EDPS_CSN      : '', // 전산고객번호
    shtrMltacOpnYn: '', //SHTR_MLTAC_OPN_YN    : '', // 단기다계좌개설여부
    trnFnsgYn: '', //TRN_FNSG_YN      : '', // 거래완료여부
    mnrcClosTs: '',
    grpKeyVl: '', //GRP_KEY_VL      : '', // 그룹KEY값- 콤보인경우만 내려옴 (전행고객실명대체번호^개인법인상세구분코드^거래년월일^거래내역일련번호)
    mrknCosnYn: '', //MRKN_COSN_YN     : '', // 마케팅동의여부
    ncpStmtYn: '',
    psvtGrdnDcd: '',
    age: -1, //AGE        : '', // 나이
    cusElcrAdr: '',
    fatcaRgsnYn: '',
    trtgRnnYn: '',
    ovrsPytxObltYn: '',
    lmtCancType: '',
    cmbJnngAblYn: '',
    acntList: [], //계좌 목록
	cpnRequired: '', //쿠폰필수사용여부
	spifCon: '',
    /*
  * 응답코드 (0: OK, 1~4: 에러)
  * 0: 정상 명의 확인 (OK)
  * 1: 본인확인 실패
  * 2: 휴대폰번호와 이름이 불일치
  * 3: 기존 가입 고객인 경우
  * 4: 가입제한 고객인 경우
    RESULT_CD                 : ''
 */
}
const slice = createSlice({
    name: 'mobileAuth',
    initialState,
    reducers: {
        clear: (state) => {
            return initialState
        },
        /**
         * 쓰나?
         * @param state
         * @param action
         * @returns
         */
        setMobileAuth: (state, action: PayloadAction<MobileAuth>) => {
            return action.payload
        },
        /**
         *
         * @param state 모바일인증 데이타 적재
         * @param action
         */
        setMobileAuthObArr: (state, action: PayloadAction<any>) => {
            Object.keys(action.payload).map((key) => {
                Object.keys(initialState).map((key1) => {
                    if (
                        key1 === key &&
                        action.payload[key] !== '' &&
                        action.payload[key] !== undefined &&
                        action.payload[key] !== null
                    ) {
                        state[key] = action.payload[key]
                    }
                })
            })
        },
        setMobileAuthArr: (state, action: PayloadAction<any>) => {
            action.payload.map((joinArr) => {
                state[joinArr.key] = joinArr.value
            })
        },
        /**
         * 전산고객번호 적재
         * @param state
         * @param action
         */
        setEdpsCsn: (state, action: PayloadAction<number>) => {
            state.edpsCsn = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            selectDep0103False.matchFulfilled,
            (state, action) => {
                //API가 성공하면 가로채 넣는다.
                let fullData = { ...action.payload }
                return fullData
            }
        )
        builder.addMatcher(selectDep0103.matchFulfilled, (state, action) => {
            //API가 성공하면 가로채 넣는다.
            let fullData = { ...action.payload }
            return fullData
        })
    },
})

export const {
    clear,
    setMobileAuth,
    setMobileAuthObArr,
    setEdpsCsn,
    setMobileAuthArr,
} = slice.actions

export const selectorOnbnCusYn = (state: RootState) => {
    return state.mobileAuth.onbnCusYn
}

export default slice.reducer
